"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeXML = exports.FRAGMENT_TAG = exports.TEXT_TAG = exports.TRUSTED_TEXT_TAG = void 0;
exports.normaliseNodes = normaliseNodes;
const escape_xml_1 = require("./escape.xml");
const export_string_1 = require("./export.string");
exports.TRUSTED_TEXT_TAG = '<';
exports.TEXT_TAG = '#';
exports.FRAGMENT_TAG = '[';
function normaliseNodes(children) {
    if (Array.isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (typeof child === 'string') {
                children[i] = exports.IkeXML.text(child);
            }
        }
    }
    return children;
}
const EMPTY_ATTRS = Object.freeze({});
const EMPTY_ARRAY = Object.freeze([]);
function n(tag, attrs, children) {
    var actualAttrs;
    var actualChildren;
    if (exports.IkeXML.isVNodeChildren(attrs)) {
        actualChildren = normaliseNodes(attrs);
    }
    else if (exports.IkeXML.isNode(attrs)) {
        actualChildren = [attrs];
    }
    else if (exports.IkeXML.isVNodeAttrs(attrs)) {
        actualAttrs = attrs;
    }
    else if (typeof attrs === 'string') {
        actualChildren = [exports.IkeXML.text(attrs)];
    }
    // If a child was passed in was it wrapped in a array or not?
    if (children != null) {
        if (exports.IkeXML.isNode(children)) {
            actualChildren = [children];
        }
        else if (typeof children === 'string') {
            actualChildren = [exports.IkeXML.text(children)];
        }
        else {
            actualChildren = normaliseNodes(children);
        }
    }
    return {
        tag,
        attrs: actualAttrs || {},
        children: actualChildren || []
    };
}
const isVNodeChildren = (k) => Array.isArray(k);
const isVNodeAttrs = (k) => typeof k === 'object';
exports.IkeXML = {
    Escape: escape_xml_1.Escape,
    Export: {
        asString: export_string_1.exportVNodeToString
    },
    EMPTY_ATTRS,
    EMPTY_ARRAY,
    n,
    isVNodeChildren,
    isVNodeAttrs,
    text(text) {
        return {
            tag: exports.TEXT_TAG,
            attrs: EMPTY_ATTRS,
            children: EMPTY_ARRAY,
            text
        };
    },
    trust(text) {
        return {
            tag: exports.TRUSTED_TEXT_TAG,
            attrs: EMPTY_ATTRS,
            children: EMPTY_ARRAY,
            text
        };
    },
    fragment(...nodes) {
        return {
            tag: exports.FRAGMENT_TAG,
            attrs: EMPTY_ATTRS,
            children: nodes
        };
    },
    isNode(node) {
        return node != null && node.tag != null;
    },
    isTrustedTextNode(node) {
        return node != null && node.tag === exports.TRUSTED_TEXT_TAG;
    },
    isTextNode(node) {
        return node != null && node.tag === exports.TEXT_TAG;
    },
    isFragmentNode(node) {
        return node != null && node.tag === exports.FRAGMENT_TAG;
    }
};
//# sourceMappingURL=index.js.map